import { formatDate, toMoneyFormat } from "utils";

const withFallback = (labels: Record<number, string>) => (code: number) => labels[code] ?? `#${code}`;

/** RegistrationTranchePaymentStatus */
export const trancheStatusLabel = withFallback({
  1: "Nieopłacona",
  2: "Oczekuje na płatność",
  3: "Opłacona",
  4: "Pominięta",
  5: "Poza systemem",
});

/** AutopayPaymentStatus */
export const paymentStatusLabel = withFallback({
  1: "Oczekuje",
  2: "Opłacona",
  3: "Nieudana",
  4: "Anulowana",
  5: "Zwrot",
});

/** RefundStatus */
export const refundStatusLabel = withFallback({
  1: "W trakcie zlecania",
  2: "Zlecony",
  3: "Odrzucony",
  4: "Zrealizowany",
  5: "Nieudany",
});

/** ReconciliationPaymentSource */
export const paymentSourceLabel = withFallback({
  1: "Autopay",
  2: "Poza systemem",
  3: "Kilka kursów",
});

/** ReconciliationIssueCode */
export const issueCodeLabel = withFallback({
  1: "Płatność ≠ transze po rabacie",
  2: "Płatność bez transzy",
  3: "Transza opłacona bez płatności",
  4: "Płatność do nieopłaconej transzy",
  5: "Duplikat płatności",
  6: "Nadpłata",
  7: "Nieczytelna kwota płatności",
});

/** ReconciliationCourseWarningCode */
export const courseWarningLabel = withFallback({
  1: "Usunięty kursant z wpłatami (nie liczy się do bilansu)",
  3: "W harmonogramie są stawki trenerów, ale nie dodano kosztów trenerów",
  4: "Usunięty kursant: wpłaty minus zwroty ≠ zatrzymany przychód",
});

export const money = (value: number) => `${toMoneyFormat(value)} zł`;

/** Signed amount for issue impacts, e.g. "+6200,00 zł" / "-69,00 zł". */
export const signedMoney = (value: number) => `${value > 0 ? "+" : ""}${money(value)}`;

/** Dates arrive as Date (offset-less ISO, converted by the interceptor) or as a string ("Z" suffix). */
export const dateTime = (value?: Date | string | null) => (value ? formatDate(new Date(value), true) : "—");
